import React, { forwardRef } from 'react';
import { bool, arrayOf, shape } from 'prop-types';

import './SelectOptionList.scss';

const SelectOptionList = forwardRef((props, ref) => {
  const { active, options } = props;

  if (!active) return null;

  return (
    <ul ref={ref} className="select-option-list">
      {options}
    </ul>
  );
});

SelectOptionList.propTypes = {
  active: bool.isRequired,
  options: arrayOf(shape({})).isRequired
};

export default SelectOptionList;
